export const fetchAllCopyright = ({ isValidated, page, perPage, search }) => ({
  method: "GET",
  prefix: " ",
  endpoint: `/copyrights?page=${page}&perPage=${perPage}&search=${search}&isValidated=${isValidated}`,
  onUploadProgress: function (progressEvent) {
    var percentCompleted = Math.round(
      (progressEvent.loaded * 100) / progressEvent.total
    );
    console.log(percentCompleted, "Porcentaje");
  },
});
export const fetchCopyright = (copyrightID) => ({
  method: "GET",
  prefix: " ",
  endpoint: `/copyrights/${copyrightID}`,
});
export const deleteCopyright = (copyrightID) => ({
  method: "DELETE",
  prefix: " ",
  endpoint: `/copyrights/${copyrightID}`,
});
export const createCopyright = (payload) => ({
  method: "POST",
  prefix: " ",
  endpoint: `/copyrights/create`,
  headers: {
    "Content-Type": "application/json",
  },
  body: payload?.body,

  onUploadProgress: payload?.onUploadProgress,
});
export const updateCopyright = (payload) => ({
  method: "PUT",
  prefix: " ",
  endpoint: `/copyrights/${payload?.id}`,
  headers: {
    "Content-Type": "application/json",
  },
  body: payload?.body,

  onUploadProgress: payload?.onUploadProgress,
});
